module.exports = __webpack_public_path__ + "static/woman_set_5youngadult.45a5ffe5.svg";